<template>
    <div class="index">
        <portal to="title">Enquiries</portal>
        <portal to="actions">
            <div class="row">
                <div class="col-12 col-md-6 mb-4 d-flex justify-content-lg-start justify-content-sm-center">
                    <router-link class="btn btn-primary w-100 w-md-auto" to="/enquiries/create">
                        <i class="fa fa-clone mr-2"></i>
                        Submit a new enquiry
                    </router-link>
                </div>

                <div
                    class="col-12 col-md-6 mb-4 d-flex justify-content-lg-end justify-content-sm-between"
                    v-if="(paginator && paginator.data && paginator.data.length) || paginatorOptions.search.length"
                >
                    <vue-search-input
                        placeholder="Search enquiries"
                        v-on:search="
                            paginatorOptions.search = $event;
                            paginatorOptions.page = 1;
                        "
                        :loading="loading"
                    />
                </div>
            </div>
        </portal>

        <vue-table
            :paginator="paginator"
            :rows="3"
            :columns="3"
            :loading="loading"
            v-on:retrieve-page="paginatorOptions.page = $event"
        >
            <template v-slot:card="data">
                <h5 class="card-header-enquiry" :class="data.item | enquiryStatusClass">
                    {{ data.item | enquiryStatusText }}
                </h5>

                <div class="card-body px-4 pt-4">
                    <p class="text-muted mt-2 mb-4">
                        Number:

                        <span class="text-blue-dark" v-html="data.item.reference_number" />
                    </p>

                    <p
                        class="text-muted my-2"
                        v-for="(patient, index) in data.item.patients"
                        :key="`enquiry-${data.item.id}-patient-${patient.id}`"
                    >
                        Patient
                        <span v-if="data.item.patients.length > 1" v-html="index + 1" />
                        :
                        <span class="text-blue-dark" v-html="`${patient.first_name} ${patient.last_name}`" />
                    </p>

                    <p class="text-muted my-2" v-if="data.item.therapist">
                        Therapist:
                        <span
                            class="text-blue-dark"
                            v-html="`${data.item.therapist.first_name} ${data.item.therapist.last_name}`"
                        />
                    </p>

                    <p class="text-muted mt-4 mb-0 date">
                        {{ data.item.created_at | timeFormat }}
                    </p>
                </div>

                <div class="card-footer text-muted bg-white border-0 pb-4 rounded-lg px-4">
                    <hr class="mb-4 mt-0" />

                    <div class="d-flex align-items-center">
                        <router-link :to="`/enquiries/${data.item.id}`" class="initialism text-muted">
                            View Details

                            <i class="fa fa-chevron-right ml-2 hvr-icon"></i>
                        </router-link>
                    </div>
                </div>
            </template>
        </vue-table>
    </div>
</template>

<script>
    import Vue from 'vue';
    import moment from 'moment';

    import VueTable from '@components/table';
    import VueSearchInput from '@components/searchInput';

    import enquiriesService from '@api/enquiries';

    export default Vue.extend({
        components: {
            VueTable,
            VueSearchInput
        },
        data() {
            return {
                paginator: {},
                paginatorOptions: {
                    page: this.$route.query.page || 1,
                    search: this.$route.query.search || ''
                },
                loading: true
            };
        },
        filters: {
            enquiryStatusText(enquiry) {
                console.log(enquiry.status)
                switch (enquiry.status) {
                    case 'pending':
                    case 'assigned_to_therapist':
                        return 'Pending';
                    case 'booking_accepted':
                        return 'Booking Accepted';
                    case 'rejected_by_client':
                    case 'rejected_by_therapist':
                    case 'cancelled':
                        return 'Cancelled';
                    case 'request_booking':
                        return 'Booking requested';
                    case 'accepted':
                        return 'Waiting for your booking request';
                    default:
                        return 'Unknown';
                }
            },
            enquiryStatusClass(enquiry) {
                switch (enquiry.status) {
                    case 'pending':
                    case 'assigned_to_therapist':
                        return 'card-header-pending';
                    case 'booking_accepted':
                        return 'card-header-accepted';
                    case 'rejected_by_client':
                    case 'rejected_by_therapist':
                    case 'cancelled':
                        return 'card-header-rejected';
                    case 'request_booking':
                        return 'card-header-requested';
                    case 'accepted':
                        return 'card-header-request';
                    default:
                        return 'card-header-unknown';
                }
            },
            timeFormat(value) {
                return moment(value).format('Do MMM YYYY \\a\\t HH:mm');
            }
        },
        watch: {
            paginatorOptions: {
                deep: true,
                handler() {
                    this.fetch();
                }
            }
        },
        methods: {
            fetch() {
                this.loading = true;

                enquiriesService
                    .index(this.paginatorOptions)
                    .then((response) => {
                        this.paginator = response.data;
                    })
                    .catch((error) => {
                        window.location.href = `/error/${error.response.status}`;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.fetch();
        }
    });
</script>
